import { Component, OnInit } from '@angular/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { HttpClient } from '@angular/common/http';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-location-component',
  templateUrl: './location-component.component.html',
  styleUrls: ['./location-component.component.css'],
  providers: [DatePipe]
})
export class LocationComponentComponent implements OnInit {
  currentPage: number = 1;
  pageSize: number = 5;
  totalPages: number = 0;
  defaultPlaceholder: string = '5 items per page';
  LocationID:any='';
  locations:any;
  errorMessage: String = '';
  events : any[] = [];
  allEvents: any[] = [];
  totalCount: number;
  filteredEvents: any[] = [];

  filterBy: string = ''; 
  selectedFilterValue: string = '';
  filterOptions: string[] = [];
  searchText: string = '';

  constructor(private http: HttpClient,private router: Router,private route: ActivatedRoute, private AuthService: AuthService,  private userService: UserService) {}

  ngOnInit(): void {
    this.route.paramMap.forEach((params) => {
      this.LocationID=params.get("id")!;
      })

    this.FetchEventsData();
  }
  
  FetchEventsData(): void {
    this.userService.getevent(this.LocationID).subscribe(
      (data) => {
        this.allEvents = data;
        this.filteredEvents = [...this.allEvents]; 
        this.totalCount = this.allEvents.length;
        this.totalPages = Math.ceil(this.allEvents.length / this.pageSize);
        this.getPaginatedEvents();
        this.errorMessage = '';
      }, 
      (error) => {
        console.error('Error fetching event data:', error);
      }
    );
  }

getPaginatedEvents(): void {
  const pageSize = Number(this.pageSize)
  const startIndex = (this.currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, this.allEvents.length);
  this.events = this.filteredEvents.slice(startIndex, endIndex);
}
  
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getPaginatedEvents();
    }
  }
  
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getPaginatedEvents();
    }
  }
  
  onPageSizeChange(event: any) {
    this.pageSize = event.value;
    this.currentPage = 1;
    this.totalCount = this.filteredEvents.length; 
    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
    this.getPaginatedEvents();
  }
  

capitalizeFirstLetter(str: string | null | undefined): string {
  if (!str) {
    return '';
  }
  const capitalizedStr = str.charAt(0).toUpperCase() + str.slice(1);
  return capitalizedStr.replace(/_/g, ' ');
}

onFilterByChange(): void {
  this.selectedFilterValue = '';
}

applySearchFilter(): void {
  const searchTextLower = this.searchText.toLowerCase().trim();

  if (searchTextLower) {
    const searchWords = searchTextLower.split(/\s+/);

    this.filteredEvents = this.allEvents.filter(event => {
      const eventType = event.event_type ? event.event_type.toLowerCase() : '';
      const captureType = event.capture_type ? event.capture_type.toLowerCase() : '';

      return searchWords.every(word => eventType.includes(word) || captureType.includes(word));
    });
  } else {
    this.filteredEvents = [...this.allEvents];
  }

  this.totalCount = this.filteredEvents.length;
  this.totalPages = Math.ceil(this.totalCount / this.pageSize);
  this.currentPage = 1;
  this.getPaginatedEvents();
}
}
